export default "images/bg6.jpg";